import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import LocaleUtils from 'react-day-picker/moment';
const _ = require('lodash');

import classes from './SimplCalendar.scss';
import { connect } from 'react-redux';
import getBirthdayFromMeta from '../../helpers/getBirthdayFromMeta';

const mapActionCreators = {};

const mapStateToProps = (state, props) => {
  let staffId = '';
  try {
    staffId = state.login.staff.id;
  } catch (e) {
    console.error(e);
  }

  return {
    staff: _.filter(_.pick(state.staff.staffs, state.staff.birthdays.all), [
      'deleted_at',
      null,
    ]),
    persons: _.filter(
      _.pick(state.person.persons, state.person.birthdays.all),
      ['deleted_at', null],
    ),
    activities: _.filter(state.activity.activities, activity => {
      if (activity.deleted_at === null) {
        return true;
      }
      return false;
    }),
    tasks: _.filter(state.task.tasks, task => {
      if (typeof task !== 'undefined' && task.deleted_at === null) {
        if (task.done_by === staffId) {
          return true;
        }

        if (task.assignee_id === staffId) {
          return true;
        }
      }
      return false;
    }),
  };
};

class SimplCalendar extends React.Component {
  constructor(props) {
    super(props);
    moment.locale('de');

    this.state = {
      month: null,
    };
  }

  changeDay = day => {
    if (typeof this.props.changeDay !== 'undefined') {
      this.props.changeDay(day);
    }
  };

  changeMonth = date => {
    this.setState({
      month: date,
    });
  };

  getModifiers = () => {
    const year = moment().year();

    const activities = [];
    const birthdaysRaw = [];
    const birthdays = [];
    const tasks = [];

    this.props.staff.forEach(data => {
      const birthday = getBirthdayFromMeta(data.meta, false);
      if (birthday) {
        birthdaysRaw.push(birthday);
      }
    });

    this.props.persons.forEach(data => {
      const birthday = getBirthdayFromMeta(data.meta, false);
      if (birthday) {
        birthdaysRaw.push(birthday);
      }
    });

    birthdaysRaw.forEach(data => {
      birthdays.push(data.set('year', year - 1).toDate());
      birthdays.push(data.set('year', year).toDate());
      birthdays.push(data.set('year', year + 1).toDate());
      birthdays.push(data.set('year', year + 2).toDate());
      birthdays.push(data.set('year', year + 3).toDate());
    });

    this.props.activities.forEach(data => {
      activities.push(data.extraInfo.startDateObject);
    });

    this.props.tasks.forEach(data => {
      let date = null;
      if (data.is_done) {
        date = moment(data.done_at).toDate();
      } else if (data.due_date) {
        date = moment(data.due_date).toDate();
      }

      if (date) {
        tasks.push(date);
      }
    });

    const modifiers = {
      birthdays,
      tasks,
      activities,
    };

    return modifiers;
  };

  render() {
    const day = this.props.day.toDate();

    const modifiersStyles = {
      birthdays: {
        // color: 'white',
        // backgroundColor: '#ffc107',
      },
      tasks: {
        // color: '#ffc107',
        // backgroundColor: '#fffdee',
      },
      activities: {
        // color: '#ffc107',
        // backgroundColor: '#fffdee',
      },
    };

    return (
      <div className={classes.calendar}>
        <DayPicker
          showWeekNumbers
          month={this.state.month}
          localeUtils={LocaleUtils}
          locale="de"
          selectedDays={day}
          onDayClick={this.changeDay}
          onMonthChange={this.changeMonth}
          modifiers={this.getModifiers()}
          modifiersStyles={modifiersStyles}
        />
        <div
          className={classes.toToday}
          onClick={() => {
            this.changeDay(moment());
            this.changeMonth(new Date());
          }}
        >
          Zu Heute springen
        </div>
      </div>
    );
  }
}

SimplCalendar.propTypes = {
  changeDay: PropTypes.func,
  day: PropTypes.object,
  staff: PropTypes.array,
  persons: PropTypes.array,
  activities: PropTypes.array,
  tasks: PropTypes.array,
};

export default connect(mapStateToProps, mapActionCreators)(SimplCalendar);



// WEBPACK FOOTER //
// ./src/components/SimplCalendar/SimplCalendar.js